<template>
  <div class="modal fade" id="SecteurParametresModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true" ref="SecteurParametresModalRef">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ selectedItem ? 'Modifier' : 'Ajouter' }} un secteur</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Form ref="secteurForm" @submit="soumettre" :validation-schema="secteurSchema">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">Code secteur <span class="text-danger">*</span></label>
                  <Field name="code_secteur" v-model="code_secteur" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le code du secteur" :disabled="!!selectedItem" />
                  <ErrorMessage name="code_secteur" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">Libellé <span class="text-danger">*</span></label>
                  <Field name="libelle_secteur" v-model="libelle_secteur" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le libellé" />
                  <ErrorMessage name="libelle_secteur" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">Zone <span class="text-danger"></span></label>
                  <Field name="code_zone" v-slot="{ field }" v-model="code_zone">
                    <Multiselect :options="zones" :searchable="true" v-model="field.value" v-bind="field"
                      placeholder="Sélectionner une zone" />
                  </Field>
                  <ErrorMessage name="code_zone" class="text-danger" />
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-3 text-md-end text-xl-end text-sm-center col-sm-12">
                <button type="submit" class="btn btn-primary w-100">{{ selectedItem ? 'Modifier' : 'Enregistrer' }}</button>
              </div>
            </div>
          </Form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch, onMounted } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import Multiselect from "@vueform/multiselect";
import { hideModal, success, error } from "@/utils/utils";
import * as Yup from "yup";
import axios, { AxiosError } from "axios";

export default defineComponent({
  name: "SecteurParametresModal",
  components: { Form, Field, ErrorMessage, Multiselect },
  props: { item: { type: [String, Number, null], default: null } },
  setup: (props, { emit }) => {
    const secteurSchema = Yup.object().shape({
      code_secteur: Yup.string().required("Le code secteur est obligatoire"),
      libelle_secteur: Yup.string().required("Le libellé est obligatoire"),
      code_zone: Yup.string().notRequired(),
    });
    const secteurForm = ref<any | null>(null);
    const code_secteur = ref("");
    const libelle_secteur = ref("");
    const code_zone = ref(null);
    const zones = ref([]);
    const selectedItem = ref<any>(null);
    const SecteurParametresModalRef = ref<null | HTMLElement>(null);

    const resetForm = () => {
      code_secteur.value = "";
      libelle_secteur.value = "";
      code_zone.value = null;
      selectedItem.value = null;
    };

    const getZones = async () => {
      try {
        // TODO: Ajouter route GET /api/zones au backend
        // const response = await axios.get("/api/zones");
        // zones.value = response.data.data.map((el: any) => ({ value: el.code_zone, label: el.libelle_zone }));
      } catch (err) {
        error(err instanceof Error ? err.message : String(err));
      }
    };

    const getSecteur = async (code: string) => {
      try {
        // TODO: Ajouter route GET /api/secteur/:code au backend
        error("Route de récupération non encore implémentée au backend");
      } catch (err) {
        error(err instanceof Error ? err.message : String(err));
      }
    };

    watch(() => props.item, async (newValue) => {
      if (newValue !== null && newValue !== undefined) {
        await getSecteur(newValue as string);
      } else {
        resetForm();
      }
    }, { immediate: true });

    onMounted(() => {
      getZones();
    });

    const soumettre = async (values, { resetForm }) => {
      try {
        // TODO: Ajouter routes POST/PUT au backend
        if (selectedItem.value && selectedItem.value.code_secteur) {
          const response = await axios.put(`/api/secteur/${selectedItem.value.code_secteur}`, values);
          if (response.data && response.data.code === 200) {
            success(response.data.message || "Le secteur a été modifié avec succès");
            resetForm();
            hideModal(SecteurParametresModalRef.value);
            emit("close");
          } else {
            error(response.data?.message || "Une erreur est survenue");
          }
        } else {
          const response = await axios.post("secteur", values);
          if (response.data && response.data.code === 200) {
            success(response.data.message || "Le secteur a été enregistré avec succès");
            resetForm();
            hideModal(SecteurParametresModalRef.value);
            emit("close");
          } else {
            error(response.data?.message || "Une erreur est survenue");
          }
        }
      } catch (err) {
        error(err instanceof AxiosError ? err.response?.data?.message || "Une erreur est survenue" : "Une erreur est survenue");
      }
    };

    return { code_secteur, libelle_secteur, code_zone, zones, selectedItem, SecteurParametresModalRef, soumettre, secteurSchema, secteurForm };
  },
});
</script>
<style src="@vueform/multiselect/themes/default.css"></style>

